import { AfterViewInit, Component, Input, NgZone, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import * as Feather from 'feather-icons';
import { AppdataService } from 'src/app/services/app-data/appdata.service';
import { CommunicationInterfaceService } from 'src/app/services/communicationInterface/communication-interface.service';
import { WebsocketService } from 'src/app/services/websockets/websocket.service';
import { $b } from '../../../libs/browser_utils.js';
import { LivechatStartService } from 'src/app/services/livechat-start/livechat-start.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit, AfterViewInit {
  isLoading = false;
  appConfig: any;
  TopNavButtonType: any;
  encryptKey = 'ThisIsTheSecret';
  endButtonIcon = 'close';
  buttonText: string;
  @Input('displayName') displayName: string = '';

  constructor(
    private route: Router,
    public appDataService: AppdataService,
    private websocketService: WebsocketService,
    private commInterface: CommunicationInterfaceService,
    public zone: NgZone,
    private startService: LivechatStartService
  ) {
    console.log('%c LogoutComponent', 'color:white; background: blue;');
  }

  ngOnInit(): void {
    try {
      this.appConfig = this.appDataService.getConfig();
      this.TopNavButtonType = this.appConfig.TopNavButton.type;
      this.buttonText = this.appConfig?.TopNavButton?.buttonText;
      this.endButtonIcon = this.appConfig.TopNavButton.endButtonIcon;
    } catch (error) {
      console.error('%c Error Occured in ngOnInit', 'color: red', error);
      this.commInterface.sendUIErrors('LogoutComponent', 'ngOnInit', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in LogoutComponent.ngOnInit', JSON.stringify(error));
    }
  }

  ngAfterViewInit() {
    Feather.replace();
  }

  /**
   * Method to handle user logout trigger from UI
   */
  onLogout = () => {
    try {
      console.log('LogoutComponent: onLogout');
      this.commInterface.logToServer('info', 'LogoutComponent.onLogout', 'User triggered logout');
      setTimeout(() => {
        this.isLoading = true;
      }, 300);

      if (this.appConfig.websocket.enabled) {
        this.websocketService.endWebSocket(this.websocketService.interactionID);
      } else if (!this.appConfig.websocket.enabled) {
        this.commInterface.end('Customer ended', '');
      }
      //as commInterface.end will redirect we don't have to redirect again
      let isChatbotMode = this.appConfig?.chatBot?.enabled;
      if(isChatbotMode) 
        {
        this.onEndRedirection();
      }

    } catch (error) {
      console.error('%c Error Occured in onLogout', 'color: red', error);
      this.commInterface.sendUIErrors('LogoutComponent', 'onLogout', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in LogoutComponent.onLogout', JSON.stringify(error));
    }
  };
  
  /**
   * Method to handle page redirection
   */
  onEndRedirection(): void {
    try {
      const navigationExtras: NavigationExtras = {
        queryParamsHandling: 'preserve',
        preserveFragment: true,
        queryParams: { ...this.startService.queryParameters },
        state: { reload: true }
      };
      let isCaptchaEnabled = this.commInterface.isCaptchaEnabledFromBackend;
      let isWebsocketEnabled = this.appConfig.websocket.enabled;
      console.log("onEndRedirection navigationExtras", navigationExtras);
      this.commInterface.logToServer('info', 'LogoutComponent.onEndRedirection', 'UI home button trigger');
      if (this.appConfig?.Miscellaneous?.CustomStartPageUrl) {
        console.log("CustomStartPageUrl");
        location.href = this.appConfig?.Miscellaneous?.CustomStartPageUrl + location.search;
      } else if (this.appConfig.Miscellaneous.ThankyoupageEnabled) {
        console.log("ThankyoupageEnabled");
        this.zone.run(() => {
          this.route.navigate(['/thank-you'], navigationExtras);
        });
      } else {
        console.log("defaultpage");
        this.zone.run(() => {
          this.route.navigate(['/'], navigationExtras);
        });
      }
    } catch (error) {
      console.error('%c Error Occured in onEndRedirection', 'color: red', error);
      this.commInterface.sendUIErrors('LogoutComponent', 'onEndRedirection', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in LogoutComponent.onEndRedirection',
        JSON.stringify(error)
      );
    }
  }

  decryptAppConfig() {
    const decryptData = CryptoJS.AES.decrypt($b.GetLocalStorage('appconfig'), this.encryptKey);
    const obj = JSON.parse(decryptData.toString(CryptoJS.enc.Utf8));
    this.appConfig = obj;
  }
}
